<template>
  <div
    class="pulldown-wrapper"
    v-click-outside="handleClickOutSite"
    :class="{ disabled: disabled, 'has-arrow': arrowDownBtn }"
  >
    <div
      id="dropdownInputText"
      ref="dropdownInput"
      :class="{ 'focus-pull-down': focusWithin, 'selection-show': selectionShow, 'has-arrow': arrowDownBtn }"
      @click="toggleDropdown()"
      @mouseover="onIsHover"
      @mouseout="offIsHover"
    >
      <div v-if="!dropdownInputText[0]" class="placeholder" :class="{ 'center-text': !arrowDownBtn }">
        {{ placeholder }}
      </div>
      <div v-if="dropdownInputText[0]" class="input-text">{{ dropdownInputText[0] }}</div>
      <img
        v-if="arrowDownBtn"
        :src="isHover ? getArrowTopImage() : getArrowImage()"
        alt=""
        class="arrow-down"
        :class="{ 'arrow-top': selectionShow }"
      />
    </div>
    <div v-if="arrowDownBtn">
      <div
        v-if="selectionShow"
        class="selection-pulldown"
        id="style-scroll"
        :class="{
          'item-scroll-none': methodsList.length <= 8,
          'method-list': width !== '50%',
          'full-width': isFullWidth,
        }"
      >
        <div v-if="hasSearch" class="search-text">
          <input
            v-model="searchText"
            type="text"
            class="input-elic"
            :placeholder="searchPlacehoder"
            style="width: 100%"
            @input="debouncedSearch"
            v-on:keyup.enter="performSearch"
          />
          <img :src="require('@/assets/icons/pulldown/search-icon.svg')" alt="search icon" class="search-icon" />
        </div>
        <div class="checkbox-list">
          <div class="item pull-down-text-color" v-if="showCheckAll">
            <div class="export-checkbox">
              <input
                v-model="selectAllData"
                type="checkbox"
                :value="$t('bubble_chart.checkbox_select_all')"
                id="check-all"
                :disabled="disabledCheckAll"
                @change="handleSelectAll"
              />
              <label :class="{ disabled_label: disabledCheckAll }" for="check-all">{{
                $t('bubble_chart.checkbox_select_all')
              }}</label>
            </div>
          </div>
          <div v-for="(item, index) in methodsList" :key="index" class="item pull-down-text-color">
            <div class="export-checkbox">
              <input
                v-model="selectedData"
                type="checkbox"
                :value="item"
                :id="item[keyCheckbox]"
                @change="handleCheckData()"
                :disabled="item.disabled"
              />
              <label :class="{ disabled_label: item.disabled }" :for="item[keyCheckbox]">{{
                item[valueCheckbox]
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { calcText } from '@/utils/calcText';
import debounce from 'lodash/debounce';

export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'スコープ/カテゴリ/算定方法を選択',
    },
    width: {
      type: String,
      default: '100%',
    },
    arrowDownBtn: {
      type: Boolean,
      default: false,
    },
    selectedProp: {
      type: Array,
      default: () => [],
    },
    hasSearch: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    searchPlacehoder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
    keyCheckbox: {
      type: String,
      default: 'id',
    },
    valueCheckbox: {
      type: String,
      default: 'text',
    },
  },
  data: () => ({
    selectionShow: false,
    maxInputLength: 435,
    selectAllData: false,
    searchText: null,
    dataSearch: [],
    focusWithin: false,
    isHover: false,
    selectedData: [],
    methodsList: [],
    showCheckAll: true,
    disabledCheckAll: false,
  }),
  mounted() {
    this.maxInputLength = this.$refs.dropdownInput?.clientWidth;
    const selectedIds = this.selectedProp.map((item) => item.id);
    this.selectedData = this.dataList.filter(({ id }) => selectedIds.includes(id));
  },
  computed: {
    dropdownInputText() {
      let lessTextArr = this.selectedData?.map((item) => {
        return item[this.valueCheckbox];
      });
      return calcText(lessTextArr, this.maxInputLength);
    },
  },
  created() {
    this.debouncedSearch = debounce(this.performSearch, 500);
  },
  watch: {
    dataList: {
      handler(newVal) {
        this.dataSearch = newVal;
        this.methodsList = newVal;
        this.disabledCheckAll = !newVal.some((item) => !item.disabled);
        const selectedIds = this.selectedProp.map((item) => item.id);
        this.selectedData = newVal.filter(({ id }) => selectedIds.includes(id));
        this.$nextTick(() => {
          const selectedDataLength = this.selectedData.length;
          const initialListLength = this.dataList.filter((item) => !item.disabled).length;
          if (selectedDataLength === initialListLength && initialListLength !== 0) {
            this.selectAllData = true;
          } else {
            this.selectAllData = false;
          }
        });
      },
      deep: true,
      immediate: true,
    },
    selectedProp: {
      handler(newVal) {
        if (this.selectedData !== newVal) {
          this.selectedData = newVal;
        }
      },
    },
  },
  methods: {
    performSearch() {
      const searchTerm = this.searchText.toLowerCase().trim();
      this.methodsList = this.dataSearch.filter((item) =>
        item[this.valueCheckbox].toLowerCase().includes(searchTerm.toLowerCase()),
      );
      this.showCheckAll = false;
      if (searchTerm.includes(this.$t('bubble_chart.checkbox_select_all')) || !searchTerm) {
        this.showCheckAll = true;
      }
    },
    toggleDropdown() {
      this.maxInputLength = document.getElementById('dropdownInputText').clientWidth;
      if (this.disabled) return;
      this.selectionShow = !this.selectionShow;
      this.searchText = null;
      this.showCheckAll = true;
      if (!this.selectionShow) {
        this.$emit('updateData', this.type, this.selectedData);
      }
    },
    handleClickOutSite() {
      if (this.selectionShow) {
        this.$emit('updateData', this.type, this.selectedData);
      }
      if (this.arrowDownBtn) {
        this.selectionShow = false;
        this.focusWithin = false;
      }
    },
    submitData() {
      this.$emit('updateData', this.type, this.selectedData);
    },
    getArrowImage() {
      return require('@/assets/icons/pulldown/arrow-down.svg');
    },
    getArrowTopImage() {
      return require('@/assets/icons/pulldown/arrow-top.svg');
    },
    onIsHover() {
      this.isHover = true;
      if (this.disabled) {
        this.offIsHover();
      }
    },
    offIsHover() {
      this.isHover = false;
    },
    handleCheckData() {
      if (!this.searchText) {
        if (this.selectedData.length === this.dataList.length) {
          this.selectAllData = true;
        } else {
          this.selectAllData = false;
        }
      }
    },
    handleSelectAll() {
      this.selectedData = [];
      if (this.selectAllData) {
        this.selectedData = this.dataList.filter((item) => !item.disabled);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/components/popup/index.scss';
@import '@/components/dialogs/DialogPopupStyle/index.scss';
.input-search {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  left: 0px;
  top: 32px;
  flex: none;
  flex-grow: 0;
  outline: none;
}
.search-text {
  position: relative;
  background: $monoWhite;
  .search-icon {
    position: absolute;
    right: 9px;
    top: 10px;
    width: 20px;
    height: 20px;
  }
}
.pulldown-wrapper {
  border: none;
  position: relative;
  .selection-pulldown {
    .checkbox-list {
      max-height: 250px;
      overflow-y: auto;

      @include scrollbar();
    }
    .item {
      .export-checkbox {
        label {
          display: inline-block;
          min-width: 180px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &.disabled_label {
            color: $monoMid;
          }
        }
      }
    }
    .search-text {
      position: relative;
      .input-elic {
        width: 100%;
        margin: unset;
        box-shadow: unset;
        background: $monoWhite;
      }
      .search-icon {
        position: absolute;
        right: 9px;
        top: 10px;
        width: 20px;
        height: 20px;
      }
    }
  }
}

.pulldown-wrapper {
  #dropdownInputText:hover {
    background-color: $monoWhite;
  }
}

.focus-pull-down {
  border: 2px solid $blueMid;
  border-radius: 4px;
}

.pulldown-wrapper {
  width: 100%;
  &.box-shadow-pull-down {
    #dropdownInputText {
      box-shadow: 0px 36px 33px rgba(160, 181, 186, 0.0744044), 0px 13.1406px 12.0455px rgba(160, 181, 186, 0.10649),
        0px 6.37951px 5.84789px rgba(160, 181, 186, 0.13351), 0px 3.12736px 2.86674px rgba(160, 181, 186, 0.165596),
        0px 1.23656px 1.13351px rgba(160, 181, 186, 0.24);
    }
  }
  &.disabled {
    cursor: default;
    #dropdownInputText {
      background: $monoLight;
      color: $monoMid;
      box-shadow: 0px 1.2365612983703613px 1.1335145235061646px 0px rgba(160, 181, 186, 0.24),
        0px 3.12735652923584px 2.866743326187134px 0px rgba(160, 181, 186, 0.17),
        0px 6.379513740539551px 5.8478875160217285px 0px rgba(160, 181, 186, 0.13),
        0px 13.140592575073242px 12.04554271697998px 0px rgba(160, 181, 186, 0.11),
        0px 36px 33px 0px rgba(160, 181, 186, 0.07);
      .input-text {
        color: $monoMid;
      }
    }
    #dropdownInputText:hover {
      background-color: $monoLight !important;
      .input-text {
        color: $monoMid !important;
      }
    }
    .focus-pull-down {
      border: none !important;
      border-radius: 4px;
    }
  }
  #style-scroll::-webkit-scrollbar {
    width: 16px;
  }

  #style-scroll::-webkit-scrollbar-thumb {
    background-color: $bgMid;
    border-radius: 10px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }

  .item-scroll-none {
    overflow: hidden !important;
  }
  .description-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 32px;
    // font-family: 'Source Han Sans JP';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.03em;
    color: $monoBlack;
    background: $monoOffWhite;
    position: absolute;
    .selected-count {
      color: $monoMid;
      font-size: 13px;
      font-weight: 400;
      letter-spacing: 0.05em;
    }
  }
  .selection-pulldown {
    position: absolute;
    background: $monoWhite;
    box-shadow: 0px 36px 33px rgba(160, 181, 186, 0.0744044), 0px 13.1406px 12.0455px rgba(160, 181, 186, 0.10649),
      0px 6.37951px 5.84789px rgba(160, 181, 186, 0.13351), 0px 3.12736px 2.86674px rgba(160, 181, 186, 0.165596),
      0px 1.23656px 1.13351px rgba(160, 181, 186, 0.24);
    margin-top: 2px;
    z-index: 99;
    overflow: hidden;
    width: 429.5px;
    // font-family: 'Source Han Sans JP';
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0.03em;
    color: $monoBlack;
    border-radius: 4px;
    &.full-width {
      width: 100% !important;
    }
    &.method-list {
      width: 100%;
    }

    .item {
      min-height: 40px;
      border: 1px solid rgba(42, 42, 48, 0.1);
      border-bottom: 0;
      border-left: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-style: normal;
      display: flex;
      align-items: center;
      position: relative;

      .export-checkbox {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 7px 0px 9px 16px;
        cursor: pointer;
        input {
          appearance: none;
          width: 16px !important;
          height: 16px !important;
          background: #ffffff;
          border: 0.5px solid rgba(0, 0, 0, 0.25);
          box-shadow: inset 0px 0px 4px 2px rgba(0, 0, 0, 0.08);
          border-radius: 4px;
          cursor: pointer;
          margin-right: 8px;
        }
        label {
          width: 100%;
          cursor: pointer;
        }

        &:hover {
          background: $bgLight;
        }
        input[type='checkbox']:checked {
          appearance: none;
          box-shadow: none;
          text-align: center;
          width: 16px !important;
          height: 16px !important;
          background: $blueMid;
        }
        input[type='checkbox']:checked:after {
          content: url('../../assets/icons/checkedbox.svg');
          color: $monoWhite;
          position: absolute;
          top: 6px;
          left: 17px;
        }
        input[type='checkbox']:checked:before {
          content: '';
          height: 41px;
          border: 2px solid $blueMid;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .toggle-wrapper {
        width: 100%;

        &.layer1,
        &.layer2 {
          border-left: 0;
          border-right: 0;
        }
        .toggle-label {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 7px 14px 9px 40px;
          .toggle-icon {
            width: 10px;
            height: 10px;
          }
        }
        &.layer1 {
          .item {
            border-right: 0;
          }
          .export-checkbox {
            padding: 7px 0px 9px 40px;
            input[type='checkbox']:checked:after {
              content: url('../../assets/icons/checkedbox.svg');
              color: $monoWhite;
              position: absolute;
              top: 6px;
              left: 41px;
            }
          }
        }
      }
    }
    .search-text {
      position: relative;
      .input-elic {
        width: 100% !important;
        margin: unset;
      }
      .search-icon {
        position: absolute;
        right: 9px;
        top: 10px;
        width: 20px;
        height: 20px;
      }
    }
  }
  #dropdownInputText {
    height: 40px;
    background: $monoWhite;
    border: 1px solid $dividerBlack;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 7px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .input-text {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      color: $monoBlack;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.03em;
      padding-right: 12px;
    }
    .count-hide-text {
      color: $monoWhite;
      background: $bgDark;
      border-radius: 10px;
      font-size: 12px;
      line-height: 8px;
      width: 19px;
      height: 19px;
      padding: 5px 6px 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: right;
      letter-spacing: 0.03em;
      font-weight: 500;
      margin-left: 8px;
    }
    .placeholder {
      color: $monoMid;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      width: 100%;
      letter-spacing: 0.03em;
      padding-right: 4px;
      &.center-text {
        text-align: center;
      }
    }
    .arrow-down {
      position: absolute;
      right: 14px;
      // padding-left: 14px;
    }
  }
  .arrow-top {
    rotate: (180deg);
  }
  &:not(.has-arrow) {
    &:hover {
      #dropdownInputText {
        background: $goldLight;
        cursor: pointer;
        .input-text {
          color: $monoWhite;
        }
        .placeholder {
          &.center-text {
            color: $monoWhite;
          }
        }
        &.selection-show {
          background-color: $monoOffWhite;
          .input-text {
            color: $monoBlack;
          }
        }
      }
    }
  }
}
.reduction-settings {
  #dropdownInputText {
    padding: 7px 16px 9px;
    box-shadow: 0px 1.2365612983703613px 1.1335145235061646px 0px rgba(160, 181, 186, 0.24),
      0px 3.12735652923584px 2.866743326187134px 0px rgba(160, 181, 186, 0.17),
      0px 6.379513740539551px 5.8478875160217285px 0px rgba(160, 181, 186, 0.13),
      0px 13.140592575073242px 12.04554271697998px 0px rgba(160, 181, 186, 0.11),
      0px 36px 33px 0px rgba(160, 181, 186, 0.07);
    .input-text {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: $monoBlack;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.42px;
    }
    .placeholder {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.is-checked-getall {
  position: relative;
  &::before {
    content: '';
    height: 40px;
    border: 2px solid $blueMid;
    position: absolute;
    top: 0;
    left: 0;
  }
}
@include desktop {
  .pulldown-wrapper {
    .selection-pulldown {
      width: 238px;

      &.method-list {
        width: 100%;
      }
    }
  }
}
.is-checked-getall {
  position: relative;
  &::before {
    content: '';
    height: 40px;
    border: 2px solid $blueMid;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
